import { observer } from "mobx-react-lite";

export const CertificationLibrary = observer(() => {
  return (
    <div>CertificationsTab</div>
  )
});
